import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PackageSearch } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useAlertaFaixa } from './alertas/AlertasContexto';

// Faixa de REPOSICAO — a FILA INTEIRA, nao so a anomalia ([DA-388], 2026-07-28).
//
// Ela conta toda vitrine no minimo com mercadoria pra repor em outro lugar (prateleira do deposito
// OU pacote fechado do pai) — ou seja, as secoes "Repor da loja" + "Abrir pacote" somadas. O
// objetivo do Ruan e PREVENTIVO: ver a fila crescer e repor ANTES de zerar na prateleira com o
// cliente no balcao, em vez de ser pego de surpresa na ultima hora.
//
// Isso SUPERA a [DA-362] decisao 4 (faixa contava so o critico, vitrine em ZERO) e aceita de olhos
// abertos o risco que o principio da [DA-360] apontava (alarme que nunca zera vira papel de parede).
// O Ruan pesou o trade-off — mostrei que a fila estava em 19 — e escolheu a visibilidade: prefere o
// banner aceso empurrando a rotina de reposicao a descobrir o buraco so quando o produto acaba.
//
// Sem "X" de dispensar, pelo mesmo motivo da faixa de Inconsistencias: o numero so cai quando
// alguem ANDA ate a prateleira e repoe — dispensar seria esconder a fila em vez de andar com ela.
interface Resumo { repor: number; criticos: number }

const POLLING_MS = 5 * 60 * 1000;

export function AlertaReposicaoBanner() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [resumo, setResumo] = useState<Resumo | null>(null);

  // Mesmo publico da faixa de Inconsistencias: a fila e o trabalho do estoquista. Vendedora nao ve
  // — ela nao tem porta pra resolver, e alarme sem acao vira ruido.
  const podeVer = usuario && ['admin', 'gerente', 'estoquista'].includes(usuario.perfil);

  useEffect(() => {
    if (!podeVer) return;
    let cancelado = false;
    async function tick() {
      try {
        const r = await api.get<Resumo>('/api/reposicoes/resumo');
        if (!cancelado) setResumo(r);
      } catch { /* silencioso: a faixa some, o resto da tela nao cai por causa dela */ }
    }
    void tick();
    const id = setInterval(tick, POLLING_MS);
    return () => { cancelado = true; clearInterval(id); };
  }, [podeVer]);

  const ativo = !!(podeVer && resumo && resumo.repor > 0);
  const recolhido = useAlertaFaixa(
    'reposicao',
    ativo ? { rotulo: 'Reposicao', bg: '#f97316', borda: '#c2410c', qtd: resumo!.repor } : null,
  );

  if (!ativo || recolhido || !resumo) return null;

  const n = resumo.repor;
  return (
    <div
      style={{
        background: '#f97316',
        borderLeft: '4px solid #c2410c',
        color: '#000',
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
        cursor: 'pointer',
      }}
      onClick={() => navigate('/estoque/reposicoes')}
    >
      <PackageSearch size={16} />
      <span style={{ fontWeight: 600 }}>Reposicao:</span>
      <span>
        {n} {n === 1 ? 'produto na fila' : 'produtos na fila'} pra repor — antes de acabar na
        {' '}prateleira com o cliente na loja
      </span>
      <span style={{ marginLeft: 'auto', textDecoration: 'underline' }}>Repor</span>
    </div>
  );
}
